const THREE = require('three');

/* eslint-disable */
const cities = {
 'mobile':[
   {"name": "Cologne", "lat": 50.930003681499997, "lng": 6.9500044338300002},
   {"name": "Reykjavík", "lat": 64.150023619699994, "lng": -21.950014487200001},
   {"name": "Kraków", "lat": 50.059979267499997, "lng": 19.960011351199999},
   {"name": "Helsinki", "lat": 60.175563374, "lng": 24.934126341500001},
   {"name": "Madrid", "lat": 40.400026264499999, "lng": -3.683351686},
   {"name": "Athens", "lat": 37.983326231900001, "lng": 23.733321084300002},
   {"name": "London", "lat": 51.499994729699999, "lng": -0.11672184386},
   {"name": "Rome", "lat": 41.895955626499997, "lng": 12.4832584215},
   {"name": "Paris", "lat": 48.866692931199999, "lng": 2.3333353257399998},
   {"name": "Hamburg", "lat": 53.55002463690, "lng": 9.99999914413},
   {"name": "Shanghai", "lat": 31.21645245260, "lng": 121.43650467800},
 ],
 'desktop':[
   {"name": "La Coruña", "lat": 43.3299766226, "lng": -8.4199876316599997},
   {"name": "Edinburgh", "lat": 55.948327859599999, "lng": -3.2190906182900001},
   {"name": "Palermo", "lat": 38.125023009300001, "lng": 13.350027220299999},
   {"name": "Zagreb", "lat": 45.800006733300002, "lng": 15.999994668199999},
   {"name": "Sofia", "lat": 42.683349425300001, "lng": 23.316654010699999},
   {"name": "Gdańsk", "lat": 54.359975198500003, "lng": 18.640040241200001},
   {"name": "Budapest", "lat": 47.500006326399998, "lng": 19.0833206774},
   {"name": "Barcelona", "lat": 41.383299579899997, "lng": 2.1833703192299998},
   {"name": "Bucharest", "lat": 44.433371804899998, "lng": 26.099946654},
   {"name": "Lisbon", "lat": 38.722722877899997, "lng": -9.1448663054899999},
   {"name": "Oslo", "lat": 59.916690286399998, "lng": 10.749979206000001},
   {"name": "Dublin", "lat": 53.333061135999998, "lng": -6.2489056817800002},
   {"name": "Milan", "lat": 45.4699751984, "lng": 9.2050089097600001},
   {"name": "Munich", "lat": 48.129942036000003, "lng": 11.574993447500001},
   {"name": "Stockholm", "lat": 59.350759954300003, "lng": 18.0973347328},
   {"name": "Amsterdam", "lat": 52.349968688099999, "lng": 4.9166401760099996},
   {"name":"Berlin", "lat": 52.521818663600001, "lng": 13.4015486233},
   {"name": "Copenhagen", "lat": 55.678564190400003, "lng": 12.5634857473},
   {"name": "Kemi", "lat": 65.73331199050, "lng": 24.58169307320},
   {"name": "Minsk", "lat": 53.89997743640, "lng": 27.56662715530},
   {"name": "Kiev", "lat": 50.43336732900, "lng": 30.51662796910},
   {"name": "Lyon", "lat": 45.77000856430, "lng": 4.83003047549},
   {"name": "Bordeaux", "lat": 44.85001304020, "lng": -0.59501306294},
   {"name": "Tirana", "lat": 41.32754070950, "lng": 19.81888301460},
   {"name": "Sarajevo", "lat": 43.85002239900, "lng": 18.38300166700},
   {"name": "Murcia", "lat": 37.97999310210, "lng": -1.12996749003},
   {"name": "Marseille", "lat": 43.28997906400, "lng": 5.37501013044},
 ]
}

/* eslint-enable */
class CityLabels {
  constructor(renderer, camera, scene, radius=10) {
    this.renderer = renderer;
    this.camera = camera;
    this.scene = scene;
    this.radius = radius;
    this.container = document.getElementById('labels-container');
    this.textLabels = []
    this.dots = []
    this.populate();
    this.updatePosition()
    this.setVisible(false);
  }
  populate(){
    var geometry = new THREE.BoxGeometry( 0.01, 0.01, 0.01 );
    var material = new THREE.MeshBasicMaterial({ color: 0xffffff, depthTest: false, transparent:true });
    for (var i = 0; i < cities.mobile.length; i++) {
      const mesh = new THREE.Mesh(geometry, material);
      mesh.renderOrder = 5;
      const coord = this.convertToSphereCoords(cities.mobile[i].lat, cities.mobile[i].lng, this.radius)
      this.scene.add(mesh);
      mesh.position.x = coord[0];
      mesh.position.y = coord[1];
      mesh.position.z = coord[2];
      this.dots.push(mesh);
      const l = this.createTextLabel(cities.mobile[i].name)
      l.setParent(mesh)
      if(i>=cities.mobile.length-2) l.siberian = true;
      this.textLabels.push(l);
    }
    if(window.innerWidth>1024){
    for (i = 0; i < cities.desktop.length; i++) {
      const mesh = new THREE.Mesh(geometry, material);
      const coord = this.convertToSphereCoords(cities.desktop[i].lat, cities.desktop[i].lng, this.radius)
      this.scene.add(mesh);
      mesh.position.x = coord[0];
      mesh.position.y = coord[1];
      mesh.position.z = coord[2];
      this.dots.push(mesh);
      const l = this.createTextLabel(cities.desktop[i].name)
      l.setParent(mesh)
      this.textLabels.push(l);
    }
  }
  }
  convertToSphereCoords(lat, lon, sphere_radius) {
    return [Math.cos(lat * Math.PI / 180) * Math.cos(lon * Math.PI / 180) * sphere_radius,
      Math.cos(lat * Math.PI / 180) * Math.sin(lon * Math.PI / 180) * sphere_radius,
      Math.sin(lat * Math.PI / 180) * sphere_radius];

    }
    createTextLabel(label) {
      var div = document.createElement('div');
      this.container.appendChild(div);
      div.className = 'text-label';
      div.style.position = 'absolute';
      div.style.width = 100;
      div.style.height = 100;
      div.innerHTML = label;
      div.style.top = -10000;
      div.style.left = -10000;
      var _this = this;

      return {
        label: label,
        element: div,
        parent: false,
        position: new THREE.Vector3(0,0,0),
        setHTML: function(html) {
          this.element.innerHTML = html;
        },
        setParent: function(threejsobj) {
          this.parent = threejsobj;
        },
        updatePosition: function() {
          if(parent) {
            this.position.copy(this.parent.position);
          }

          var coords2d = this.get2DCoords(this.parent, _this.camera);
          this.element.style.left = coords2d.x + 'px';
          this.element.style.top = coords2d.y + 'px';
        },
        get2DCoords: function(object, camera) {
          const w = window.innerWidth;
          const h = window.innerHeight;
          const tempV = new THREE.Vector3();
          // get the position of the center of the cube
          object.updateWorldMatrix(true, false);
          object.getWorldPosition(tempV);

          // get the normalized screen coordinate of that position
          // x and y will be in the -1 to +1 range with x = -1 being
          // on the left and y = -1 being on the bottom
          tempV.project(camera);

          // convert the normalized position to CSS coordinates
          const x = (tempV.x *  .5 + .5) * w;
          const y = (tempV.y * -.5 + .5) * h;
          return new THREE.Vector2(x, y)
        }
      };
    }
    updatePosition() {
      this.textLabels.forEach((label) =>{
        label.updatePosition();
      });
    }
    setFact(f){
      if(f==12){
        for(let i = 0; i< this.textLabels.length; i++){
          if(this.textLabels[i].siberian){
            this.dots[i].visible = true
            this.textLabels[i].element.style.opacity = 1;
          } else{
            this.dots[i].visible = false 
            this.textLabels[i].element.style.opacity = 0
          }
        }
        setTimeout(()=>{this.showLabels(true)},500);

      } else {
        for(let i = 0; i< this.textLabels.length; i++){
          this.dots[i].material.opacity = this.textLabels[i].element.style.opacity = 1;
        }
        this.showLabels(this.visible)
      }
    }

    showLabels(v){
      if(v) this.container.style.opacity = 1;
      else this.container.style.opacity = 0;
      this.dots.forEach((dot) =>{
        dot.visible = v;
      });
    }

    setVisible(v) {
        this.showLabels(v);
        this.visible = v;
    }

    update() {
    }
  }
  export default CityLabels;
